import PropTypes from 'prop-types';
import React from 'react';

import { currencyFormattedNumber } from '../../lib/numberFormatter';
import CostOfAttendanceBreakdownModal from '../../pages/modals/CostOfAttendanceBreakdownModal';
import { periodPropTypes } from '../../reducers/propTypes';

import './index.scss';

const PeriodCostBanner = ({ periods, currentPeriod }) => {
  let costOfAttendance = 0;
  let costOfLiving = 0;
  let costOfTuition = 0;
  periods.forEach(period => {
    costOfAttendance += period.costOfLiving + period.costOfTuition;
    costOfLiving += period.costOfLiving;
    costOfTuition += period.costOfTuition;
  });

  const { currency } = periods[0] || '';

  let formattedCostOfAttendance = 0;
  let formattedCostOfTuition = 0;
  let formattedCostOfLiving = 0;
  if (currency) {
    formattedCostOfAttendance = currencyFormattedNumber(currency, costOfAttendance);
    formattedCostOfTuition = currencyFormattedNumber(currency, costOfTuition);
    formattedCostOfLiving = currencyFormattedNumber(currency, costOfLiving);
  }

  const showBreakdownLink = () => multiplePeriods();
  const multiplePeriods = () => periods.length > 1;

  return (
    <div className="period-cost-banner">
      <div className="container container--space-y">
        <div className="row">
          <div className="col">
            <h2>
              The total cost of your course is approximately
              <strong> {formattedCostOfAttendance}</strong>.
            </h2>
            <p>
              We get this amount from your school and it includes {formattedCostOfTuition} for
              tuition and {formattedCostOfLiving} for living costs.
            </p>
            {showBreakdownLink() && (
              <CostOfAttendanceBreakdownModal periods={periods} currentPeriod={currentPeriod} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

PeriodCostBanner.propTypes = {
  periods: PropTypes.arrayOf(periodPropTypes).isRequired,
  currentPeriod: PropTypes.string.isRequired,
};

export default PeriodCostBanner;
